import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const FaqWrite = () => {
  const navigate = useNavigate();
  const { board_seq } = useParams();

  // const uploadInput = useRef();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [category, setCategory] = useState("결제문의");
  const [answer, setAnswer] = useState("");

  useEffect(() => {
    if (board_seq) {
      // Fetch existing board data
      const fetchBoardData = async () => {
        const formData = new FormData();
        formData.append("board_seq", board_seq);

        try {
          const successHandler = (response) => {
            const data = response.data;
            setTitle(data.board_title);
            setContent(data.board_content);
            setCategory(data.board_cate || "결제문의");
            setAnswer(data.board_content2 || "");
          };

          const errorHandler = (error) => {
            toast.error("자주 묻는 질문 불러오기 중 오류가 발생했습니다.");
          };

          await request.get(`/board/list/admin/BD_FAQ/${board_seq}`, formData, successHandler, errorHandler);
        } catch (error) {
          toast.error("자주 묻는 질문 불러오기 중 오류가 발생했습니다.");
        }
      };

      fetchBoardData();
    }
  }, [board_seq]);

  const handleTitleChange = (e) => setTitle(e.target.value);
  const handleContentChange = (e) => setContent(e.target.value);
  const handleCategoryChange = (e) => setCategory(e.target.value);
  const handleAnswerChange = (e) => setAnswer(e.target.value);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("board_title", title);
    formData.append("board_content", content);
    formData.append("board_cate", category);
    formData.append("board_content2", answer);

    // if (uploadInput.current.files[0]) {
    //   formData.append("image", uploadInput.current.files[0]);
    // }

    try {
      const successHandler = (response) => {
        if (response.messageCode === 200) {
          toast.success(`자주 묻는 질문이 성공적으로 ${board_seq ? "수정" : "등록"}되었습니다.`);
          navigate("/Manage/Faq");
        } else {
          toast.error(`자주 묻는 질문 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
        }
      };

      const errorHandler = (error) => {
        toast.error(`자주 묻는 질문 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
      };

      if (board_seq) {
        await request.put(`/board/BD_FAQ/${board_seq}`, formData, successHandler, errorHandler);
      } else {
        await request.put("/board/BD_FAQ", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error(`자주 묻는 질문 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">자주 묻는 질문 {board_seq ? "수정" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            <tr>
              <th>분류</th>
              <td colSpan={3}>
                <select className="select ws" value={category} onChange={handleCategoryChange}>
                  <option value="결제문의">결제문의</option>
                  <option value="서비스문의">서비스문의</option>
                  <option value="기타문의">기타문의</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td colSpan={3}>
                <input
                  type="text"
                  className="input"
                  value={title}
                  onChange={handleTitleChange}
                />
              </td>
            </tr>
            <tr>
              <th>문의내용</th>
              <td colSpan={3}>
                <textarea
                  className="textarea"
                  value={content}
                  onChange={handleContentChange}
                  rows="10"
                />
              </td>
            </tr>
            <tr>
              <th>답변</th>
              <td colSpan={3}>
                <textarea
                  className="textarea"
                  value={answer}
                  onChange={handleAnswerChange}
                  rows="10"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{board_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Manage/Faq")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default FaqWrite;
